import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { PqrReceivedThroughFilters } from './filters';
import { PqrReceivedThroughList } from './list';
import {
    PQR_RECEIVED_THROUGH,
    PQR_RECEIVED_THROUGH_NEW,
} from '../../../../routes/paths';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import { Param } from '../../../../shared/types/param';

export const PqrReceivedThrough = () => {
    const [filters, setFilters] = useState<Param>();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    return (
        <>
            <LayoutModule
                title="Búsqueda de medio PQR"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: PQR_RECEIVED_THROUGH_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_RECEIVED_THROUGH,
                        }}
                    />
                }
            >
                <PqrReceivedThroughFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <PqrReceivedThroughList filters={filters} />
        </>
    );
};
